'use client'
import {
  setUserInLocalStorage
} from "./chunk-4RITNUKZ.mjs";
import {
  CHECKOUT_DATA_COOKIE_NAME,
  USER_DATA_STORAGE_KEY
} from "./chunk-T2NN7R53.mjs";
import {
  __async
} from "./chunk-UYSR6ZT4.mjs";

// src/utils/data.ts
import {
  COUNTRIES,
  addVatToPrice,
  generateSHA256Hash,
  getItem,
  safeParseJson,
  setItem
} from "@wbk/utils";
var userData = (user, subscriptions) => __async(null, null, function* () {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
  const cellCode = COUNTRIES.find((country) => country.code === user.cell_country_code);
  const mobile = (cellCode == null ? void 0 : cellCode.dial_code) && user.cell_number ? `+${cellCode.dial_code}${user.cell_number}` : user.cell_number || "";
  const [phone_hash, email_hash] = yield Promise.all([
    generateSHA256Hash(mobile),
    generateSHA256Hash(user.email)
  ]);
  const data = {
    _id: user._id || "",
    user_id: user._id || "",
    email: user.email || "",
    phone: user.mobile || "",
    dob: user.dob || "",
    gender: user.gender || "",
    cell_country_code: user.cell_country_code || "",
    cell_number: user.cell_number || "",
    mobile,
    phone_hash,
    email_hash,
    first_name: user.first_name || "",
    last_name: user.last_name || "",
    city: user.city || "",
    country: user.country || "",
    created_at: user.created_at || "",
    address: user.address || "",
    locale: user.locale || "",
    nationality: user.nationality || "",
    email_promotion: !!user.email_promotion,
    push_promotion: !!user.push_promotion,
    sms_promotion: !!user.sms_promotion,
    whatsapp_promotion: !!user.whatsapp_promotion,
    subscription_plan: (_b = (_a = subscriptions == null ? void 0 : subscriptions[0]) == null ? void 0 : _a.plan) == null ? void 0 : _b.name,
    subscription_end_date: (_c = subscriptions == null ? void 0 : subscriptions[0]) == null ? void 0 : _c.end_date,
    subscription_status: (_d = subscriptions == null ? void 0 : subscriptions[0]) == null ? void 0 : _d.status,
    // braga
    user_type: ((_g = (_f = (_e = subscriptions == null ? void 0 : subscriptions[0]) == null ? void 0 : _e.plan) == null ? void 0 : _f.plan_group) == null ? void 0 : _g.name) || "",
    // public etc
    member_id: ((_i = (_h = subscriptions == null ? void 0 : subscriptions[0]) == null ? void 0 : _h.membership) == null ? void 0 : _i.member_number) || "",
    // id
    membership_category: ((_k = (_j = subscriptions == null ? void 0 : subscriptions[0]) == null ? void 0 : _j.plan) == null ? void 0 : _k.name) || "",
    // adult etc
    registration_date: (user == null ? void 0 : user.created_at) || "",
    season_ticket_holder: !!((_m = (_l = subscriptions == null ? void 0 : subscriptions[0]) == null ? void 0 : _l.membership) == null ? void 0 : _m.season_ticket_holder),
    direct_debit_active: !!((_n = subscriptions == null ? void 0 : subscriptions[0]) == null ? void 0 : _n.direct_debit_active),
    quota_status: ((_o = subscriptions == null ? void 0 : subscriptions[0]) == null ? void 0 : _o.quota_status) || ""
  };
  setUserInLocalStorage(data);
  return data;
});
var productData = ({
  event,
  title,
  price,
  quantity,
  zone,
  product_id,
  tickets_available,
  event_type
}) => {
  return {
    currency: (event == null ? void 0 : event.currencyCode) || (event == null ? void 0 : event.currency) || "SAR",
    value: price || (event == null ? void 0 : event.startingPrice) || 0,
    product_image_url: (event == null ? void 0 : event.poster) || "",
    page_type: (event == null ? void 0 : event.page_type) || "",
    booking_type: (event == null ? void 0 : event.contentful_entity_type) || "",
    event_name: (event == null ? void 0 : event.title) || title,
    event_slug: (event == null ? void 0 : event.slug) || "",
    tickets_available,
    event_type,
    items: [
      {
        id: (event == null ? void 0 : event._id) || product_id,
        item_id: (event == null ? void 0 : event._id) || product_id,
        item_name: (event == null ? void 0 : event.title) || title,
        item_category: (event == null ? void 0 : event.category) || "N/A",
        price: price || (event == null ? void 0 : event.startingPrice) || 0,
        quantity: quantity || 1,
        zone: (event == null ? void 0 : event.zone) || zone || "",
        google_business_vertical: "retail",
        start_date_time: event == null ? void 0 : event.start_date_time,
        end_date_time: event == null ? void 0 : event.end_date_time,
        country: (event == null ? void 0 : event.country) || ""
      }
    ]
  };
};
var productDataFlat = ({ event, title, price, zone, product_id }) => {
  return {
    currency: (event == null ? void 0 : event.currencyCode) || (event == null ? void 0 : event.currency) || "SAR",
    product_image_url: (event == null ? void 0 : event.poster) || "",
    id: (event == null ? void 0 : event._id) || product_id,
    slug: (event == null ? void 0 : event.slug) || "",
    name: (event == null ? void 0 : event.title) || title,
    category: (event == null ? void 0 : event.category) || "N/A",
    price: price || (event == null ? void 0 : event.startingPrice) || 0,
    zone: (event == null ? void 0 : event.zone) || zone || "",
    start_date_time: event == null ? void 0 : event.start_date_time,
    end_date_time: event == null ? void 0 : event.end_date_time,
    country: (event == null ? void 0 : event.country) || "",
    page_path: typeof window === "undefined" ? void 0 : window.location.pathname
  };
};
var cartData = ({
  item,
  quantity,
  event,
  itemValue,
  currency,
  id,
  title,
  zone,
  vat
}) => {
  const userDataString = getItem(USER_DATA_STORAGE_KEY) || "";
  const userData2 = safeParseJson(userDataString);
  const originalPrice = addVatToPrice(item == null ? void 0 : item.original_price);
  const value = item ? +item.price + (+item.vat || 0) : (itemValue || 0) + (vat || 0) || itemValue || 0;
  const hasDiscount = (item == null ? void 0 : item.price) !== (item == null ? void 0 : item.original_price);
  const discount = item && hasDiscount ? originalPrice - value : 0;
  const order = {
    currency: (item == null ? void 0 : item.currency) || (event == null ? void 0 : event.currencyCode) || (event == null ? void 0 : event.currency) || currency,
    value: value * (quantity || 1),
    product_image_url: event == null ? void 0 : event.poster,
    event_slug: event == null ? void 0 : event.slug,
    page_type: (event == null ? void 0 : event.page_type) || "",
    booking_type: (event == null ? void 0 : event.booking_type) || "",
    event_name: title || (event == null ? void 0 : event.title),
    items: [
      {
        item_id: (item == null ? void 0 : item._id) || id,
        item_name: (event == null ? void 0 : event.title) || title,
        item_category: (event == null ? void 0 : event.category) || "N/A",
        country: (event == null ? void 0 : event.country) || "",
        organization_slug: (event == null ? void 0 : event.organization_slug) || "",
        quantity,
        original_price: originalPrice,
        price: value,
        discount,
        ticket_class: item == null ? void 0 : item.title,
        zone: (event == null ? void 0 : event.zone) || zone,
        google_business_vertical: "retail",
        id: (item == null ? void 0 : item._id) || id,
        currency: (item == null ? void 0 : item.currency) || (event == null ? void 0 : event.currencyCode) || (event == null ? void 0 : event.currency) || currency,
        deal_percentage: item == null ? void 0 : item.deal_percentage,
        deal_amount: item == null ? void 0 : item.deal_amount,
        deal_label: item == null ? void 0 : item.deal_label,
        deal_type: item == null ? void 0 : item.deal_type,
        is_super_deal: item == null ? void 0 : item.is_super_deal,
        deal_id: item == null ? void 0 : item.deal_id,
        super_deal_count: (event == null ? void 0 : event.super_deal_count) || 0,
        total_amount_saved: (event == null ? void 0 : event.total_amount_saved) || 0
      }
    ],
    /** Meta/Snapchat helpers */
    number_items: quantity,
    item_ids: [(item == null ? void 0 : item._id) || id]
  };
  return { order, userData: userData2 };
};
var checkoutData = ({
  items,
  coupon,
  event,
  zone,
  payment_method
}) => {
  var _a;
  const totalValue = items.reduce(
    (acc, item) => acc + (+item.price + (item.vat ? +item.vat : 0)) * item.qty,
    0
  );
  const userDataString = getItem(USER_DATA_STORAGE_KEY) || "";
  const userData2 = safeParseJson(userDataString);
  const checkoutData2 = {
    item_name: event == null ? void 0 : event.title,
    item_category: (event == null ? void 0 : event.category) || "N/A",
    zone: (event == null ? void 0 : event.zone) || zone
  };
  setItem(CHECKOUT_DATA_COOKIE_NAME, JSON.stringify(checkoutData2));
  const order = {
    currency: ((_a = items[0]) == null ? void 0 : _a.currency) || (event == null ? void 0 : event.currencyCode) || (event == null ? void 0 : event.currency) || "SAR",
    value: totalValue,
    coupon: (coupon == null ? void 0 : coupon.promo_code) || "",
    product_image_url: (event == null ? void 0 : event.poster) || "",
    page_type: (event == null ? void 0 : event.page_type) || "",
    booking_type: (event == null ? void 0 : event.booking_type) || "",
    has_subscription_upgrade: (event == null ? void 0 : event.has_subscription_upgrade) || false,
    event_name: event == null ? void 0 : event.title,
    items: items == null ? void 0 : items.map((item) => {
      var _a2;
      const ticketId = item.ticket_id || item._id;
      const value = +(+item.price + (item.vat ? +item.vat : 0));
      const discount = +item.original_price - value;
      const hasCoupon = ticketId && ((_a2 = coupon == null ? void 0 : coupon.ticket_ids) == null ? void 0 : _a2.includes(ticketId));
      const couponedDiscount = hasCoupon && (coupon == null ? void 0 : coupon.discount) ? +item.price * coupon.discount / 100 : 0;
      const eventZone = (item == null ? void 0 : item.zone) || (event == null ? void 0 : event.zone) || zone;
      const ticketClass = item.ticket_class || item.title;
      return {
        item_id: ticketId,
        item_name: item.title,
        item_category: (event == null ? void 0 : event.category) || "N/A",
        country: (event == null ? void 0 : event.country) || "",
        organization_slug: (event == null ? void 0 : event.organization_slug) || "",
        quantity: item.qty,
        price: value,
        discount: couponedDiscount ? couponedDiscount : discount,
        zone: eventZone,
        google_business_vertical: "retail",
        ticket_class: ticketClass,
        id: ticketId,
        deal_percentage: item.deal_percentage,
        deal_amount: item.deal_amount,
        deal_label: item.deal_label,
        deal_type: item.deal_type,
        is_super_deal: item.is_super_deal,
        deal_id: item.deal_id,
        super_deal_count: (event == null ? void 0 : event.super_deal_count) || 0,
        total_amount_saved: (event == null ? void 0 : event.total_amount_saved) || 0,
        billing_period: item.billing_period || null
      };
    }),
    /** Meta/Snapchat helpers */
    number_items: items == null ? void 0 : items.reduce((acc, item) => acc + item.qty, 0),
    item_ids: items == null ? void 0 : items.map((item) => item.ticket_id || item._id),
    payment_method: payment_method || ""
  };
  return { order, userData: userData2 };
};
var purchaseData = (payment) => {
  var _a, _b, _c;
  const summaries = payment.summary || payment.summaries || [];
  const userDataString = getItem(USER_DATA_STORAGE_KEY) || "";
  const userData2 = safeParseJson(userDataString);
  const checkoutDataString = getItem(CHECKOUT_DATA_COOKIE_NAME) || "";
  const checkoutData2 = safeParseJson(checkoutDataString);
  let superDealCount = 0;
  const items = summaries.flatMap((summary) => {
    var _a2;
    const dealMap = new Map(
      ((_a2 = summary.tickets_details) != null ? _a2 : []).map((detail) => {
        var _a3;
        if ((_a3 = detail.deal) == null ? void 0 : _a3.deal_id) {
          superDealCount += 1;
        }
        return [detail.event_ticket_id, detail.deal];
      })
    );
    return summary.tickets.map((item) => {
      var _a3, _b2, _c2, _d, _e;
      const deal = dealMap.get(item._id);
      return {
        item_id: item._id,
        item_name: ((_a3 = summary.event) == null ? void 0 : _a3.title) || "",
        item_category: checkoutData2 == null ? void 0 : checkoutData2.item_category,
        quantity: item.qty,
        price: +item.price,
        ticket_class: item.title,
        item_category2: ((_b2 = summary.event) == null ? void 0 : _b2.city) || "",
        zone: checkoutData2 == null ? void 0 : checkoutData2.zone,
        google_business_vertical: "retail",
        id: item._id,
        total_amount_saved: payment.deal_discount_amount,
        deal_percentage: (_c2 = deal == null ? void 0 : deal.discount_percentage) != null ? _c2 : (deal == null ? void 0 : deal.discount_amount) ? deal.discount_amount / deal.original_price * 100 : void 0,
        deal_amount: (_d = deal == null ? void 0 : deal.discount_amount) != null ? _d : (deal == null ? void 0 : deal.discount_percentage) ? deal.original_price * (deal.discount_percentage / 100) : void 0,
        deal_label: deal == null ? void 0 : deal.label_prefix,
        deal_type: (_e = deal == null ? void 0 : deal.deal_type) == null ? void 0 : _e.name,
        is_super_deal: !!(deal == null ? void 0 : deal.deal_id),
        deal_id: deal == null ? void 0 : deal.deal_id,
        super_deal_count: superDealCount
      };
    });
  });
  const event = summaries == null ? void 0 : summaries[0].event;
  const timeSlot = (_b = (_a = summaries == null ? void 0 : summaries[0].tickets) == null ? void 0 : _a[0]) == null ? void 0 : _b.time_slots;
  let eventDateInSeconds = event.start_date_time;
  if (payment.seven_rooms_details) {
    eventDateInSeconds = Math.floor(
      new Date(payment.seven_rooms_details.time_iso).getTime() / 1e3
    );
  } else if (payment.servme_details) {
    const servmeDate = /* @__PURE__ */ new Date(`${(_c = payment.servme_details) == null ? void 0 : _c.date} ${payment.servme_details.time}`);
    eventDateInSeconds = Math.floor(servmeDate.getTime() / 1e3);
  } else if (timeSlot == null ? void 0 : timeSlot.time_from) {
    const fallbackDate = new Date(timeSlot.time_from);
    eventDateInSeconds = Math.floor(fallbackDate.getTime() / 1e3);
  }
  const order = {
    booking_type: payment.contentful_entity_type || "",
    transaction_id: payment.order_id,
    transaction_type: payment.is_resale ? "resell" : "",
    event_id: event == null ? void 0 : event._id,
    event_slug: event == null ? void 0 : event.slug,
    event_date: eventDateInSeconds,
    event_name: (event == null ? void 0 : event.title) || "",
    currency: payment.total.currency,
    shipping: 0,
    tax: payment.total.vat_total,
    value: payment.total.grand_total,
    discount: payment.total.discount_amount,
    payment_type: payment.booked_type,
    coupon: payment.promo_code || "",
    product_image_url: (event == null ? void 0 : event.poster) || "",
    items,
    /** Meta/Snapchat helpers */
    number_items: items.length,
    item_ids: items.map((item) => item.item_id),
    insider_booking_payload: payment.insider_booking_payload
  };
  return { order, userData: userData2 };
};
var subscriptionPurchaseData = (subscription) => {
  var _a;
  const userDataString = getItem(USER_DATA_STORAGE_KEY) || "";
  const userData2 = safeParseJson(userDataString);
  const checkoutDataString = getItem(CHECKOUT_DATA_COOKIE_NAME) || "";
  const checkoutData2 = safeParseJson(checkoutDataString);
  const subscriptionId = subscription.plan.plan_group._id;
  const items = {
    item_id: subscriptionId,
    item_name: subscription.plan.name || "",
    item_category: checkoutData2 == null ? void 0 : checkoutData2.item_category,
    quantity: 1,
    price: subscription.plan.price,
    item_category2: subscription.plan.name || "",
    google_business_vertical: "retail",
    id: subscriptionId,
    billing_period: ((_a = subscription.plan.payment_terms) == null ? void 0 : _a.toLowerCase()) || null
  };
  const order = {
    transaction_id: subscription._id,
    event_id: subscriptionId,
    event_slug: subscription.plan.plan_group._id,
    event_date: subscription.start_date,
    currency: subscription.plan.currency,
    shipping: 0,
    tax: subscription.plan.vat,
    value: subscription.payment_session.grand_total,
    payment_type: "order_subscription",
    product_image_url: subscription.subscription.poster || "",
    items: [items],
    /** Meta/Snapchat helpers */
    number_items: 1,
    item_ids: [subscriptionId]
  };
  return { order, userData: userData2 };
};

export {
  userData,
  productData,
  productDataFlat,
  cartData,
  checkoutData,
  purchaseData,
  subscriptionPurchaseData
};
//# sourceMappingURL=chunk-CQOC5ALZ.mjs.map